import React from "react";
import Pagination from "../Pagination/Pagination";

const PagesResult = (props) => {
    return (
        <div
            className={"tab-pane fade show " + (props.initialTab === "pages" ? "active" : "")}
            id="pills-pages"
            role="tabpanel"
            aria-labelledby="pills-pages-tab"
        >
            {props.pages?.length > 0 ? (
                <>
                    {/* Pagination */}
                    <Pagination
                        handlePageChange={props.handleChange}
                        currentPage={props.pagesPage}
                        pagination={props.pagination}
                    />

                    {/* Results */}
                    <ul className="c-quick-search__result">
                        {props.pages.map((item, i) => {
                            return (
                                <li key={i} className="item content-result-item">
                                    <a href={item.url}>
                                        <span>
                                            <b>{item.title}</b>
                                        </span>
                                        <span>{item.description}</span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </>
            ) : (
                <div class="no-results-container">{i18n.getString("quicksearch.nomatchingresults")}</div>
            )}
        </div>
    );
};

export default React.memo(PagesResult);
